export default __webpack_public_path__ + "static/media/cauliflower_rice.17a0f2c4.jpg";